<template>
  <v-menu
    max-width="auto"
    min-width="1%"
    :close-on-content-click="false"
    v-model="datePickerVisible"
  >
    <template v-slot:activator="{}">
      <v-text-field
        ref="textField"
        v-mask="'####-##-##'"
        v-model="formattedInternalValue"
        :label="label"
        :messages="messages"
        :success-messages="successMessages"
        prepend-icon="mdi-calendar"
        :error-count="errormessages[itemId] ? (errormessages[itemId].length || 1) : 1"
        :error-messages="errormessages[itemId] ? errormessages[itemId] : []"
        @click="clearErrors"
        @click:prepend="clearErrors(); datePickerVisible=true"
        @click:append="clearErrors"
        @blur="pickerValue = internalVal = $options.filters.date(Date.parse(internalVal))"
      >
        <template #append>
          <v-btn text x-small color="primary" @click="setToday" class="date-today-btn">{{ $t('app.today') }}</v-btn>
        </template>
      </v-text-field>
    </template>

    <v-date-picker
      no-title
      scrollable
      v-model="pickerValue"
      @input="datePickerVisible = false"
    >

    </v-date-picker>
  </v-menu>
</template>

<script>
/* eslint-disable */
import {mapGetters} from 'vuex'

export default {
  name: "DatePickerField",
  data() {
    return {
      internalVal: null,
      pickerValue: null,
      datePickerVisible: false,
      internalErrormessages: [],
      switchedMode: false
    }
  },

  watch: {
    itemId: {
      // eslint-disable-next-line object-shorthand
      handler: function(v) {
        if (typeof this.internalErrormessages[v] === 'undefined') {
          this.internalErrormessages[v] = (this.errors && this.errors.length) ? this.errors.map(e => e.errormsg[this.locale]) : []
        }
      },
      immediate: true
    },
    value(v) {
      //console.log(`value: ${v}`)
      this.internalVal = this.isValidDate(v) ? this.$options.filters.date(v) : v
      this.pickerValue = this.isValidDate(v) ? this.$options.filters.date(v) : null
    },
    internalVal(v) {
      if (this.isValidDate(v) || this.nullableMode) {
        //console.log(`internalVal: emitting ${v} ${this.isValidDate(v)} ${this.nullableMode}`)
        if (this.isValidDate(v)) {
          this.$emit('input', v)
        } else {
          this.$emit('input', null)
        }
      }
    },
    pickerValue(v) {
      this.internalVal = v
    },
    nullableMode(v) {
      this.switchedMode = true
      if (v) {
        this.internalVal = '1970-01-01'
        this.value = '1970-01-01'
        this.pickerValue = '1970-01-01'
      }
    }
  },

  mounted() {
    this.internalVal = this.value;
  },

  computed: {
    ...mapGetters('app', ['locale']),

    formattedInternalValue: {
      get() {
        return ['2049-12-31'].includes(this.internalVal) ? this.$t('app.noEnd') :
          ['1970-01-01', '1900-01-01'].includes(this.internalVal) ? '' :
            this.internalVal;
      },
      set(val) {
        //console.log(`set: ${val}`)
        //- Prevent initial set when just switched mode
        if (!this.switchedMode) {
          //console.log(`set - setting internalVal: ${val}`)
          this.internalVal = val
        }
        this.switchedMode = false
      }
    },

    messages() {
      return this.nullableMode ? this.value === null || this.value === '1970-01-01' ? [this.$t('rights.editForm.noChanges')] : [] : [];
    },

    successMessages() {
      return this.nullableMode ? this.value === null || this.value === '1970-01-01' ? [] : [this.$t('rights.editForm.willEdit')] : [];
    },

    errormessages() {
      return this.nullableMode ? [] : this.internalErrormessages
    } 
  },

  methods: {
    clearErrors() {
      if (!this.nullableMode) {
        this.internalErrormessages[this.itemId] = []
      }
    },

    setToday() {
      this.internalVal = new Date().toISOString()
        .split('T')[0];
    },

    setMax() {
      this.internalVal = new Date('2049-12-31').toISOString()
        .split('T')[0];
    },
  
    isValidDate(date) {
      let d = new Date(date)
      return (
        !(Object.prototype.toString.call(d) !== '[object Date]' || isNaN(d.getTime())) &&
        Boolean(date && date.match(/^(\d{4})-(\d{2})-(\d{2})/))
      )
    }

  },
  props: {
    label: {
      type: String,
      default: 'Pick a date',
    },
    'nullableMode': {},
    value: {},
    errors: {
      type: Array
    },
    'itemId': {}
  }
}
</script>
